
<app-newsfeed-article-listing [articles]="articles"></app-newsfeed-article-listing>